import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Bannière d'évaluation affichée dans le système de suivi des réclamations
 * @param {string} trackingNumber - Numéro de suivi de la réclamation
 * @param {boolean} isRated - Indique si la réclamation a déjà été évaluée
 * @param {object} rating - Données de l'évaluation (si déjà évaluée)
 */
const RatingBanner = ({ trackingNumber, isRated, rating }) => {
    // Fonction pour afficher des étoiles sans dépendance externe
    const renderStars = (score) => {
        return (
            <div className="d-flex align-items-center">
                {[1, 2, 3, 4, 5].map((star) => (
                    <span
                        key={star}
                        style={{
                            color: star <= score ? "#FFC107" : "#E4E5E9",
                            fontSize: "20px",
                            marginRight: "4px"
                        }}
                    >
                        ★
                    </span>
                ))}
            </div>
        );
    };

    // Correction ici : utiliser rating.rating au lieu de rating.score
    // Si la réclamation a déjà été notée, afficher les étoiles
    if (isRated && rating) {
        return (
            <div className="card mb-4 border-success">
                <div className="card-body p-3">
                    <div className="d-flex align-items-center justify-content-between flex-wrap">
                        <div>
                            <h5 className="card-title mb-1">Merci pour votre évaluation !</h5>
                            <div className="d-flex align-items-center">
                                <div className="me-2">Votre note :</div>
                                {/* Correction ici : utiliser rating.rating au lieu de rating.score */}
                                {renderStars(rating.rating)}
                            </div>
                            {rating.comment && (
                                <div className="mt-2">
                                    <small className="text-muted fst-italic">"{rating.comment}"</small>
                                </div>
                            )}
                        </div>
                        <div className="mt-2 mt-md-0">
                            <span className="badge bg-success-subtle text-success">Évaluation soumise</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // Si la réclamation n'a pas encore été notée, proposer un lien pour la noter
    return (
        <div className="card mb-4 border-warning">
            <div className="card-body p-3">
                <div className="d-flex align-items-center justify-content-between flex-wrap">
                    <div>
                        <h5 className="card-title mb-1">Évaluez notre service</h5>
                        <p className="card-text mb-0">
                            Votre réclamation est clôturée. Partagez votre niveau de satisfaction pour nous aider à améliorer nos services.
                        </p>
                    </div>
                    <div className="mt-2 mt-md-0">
                        <Link 
                            to={`/rating/${trackingNumber}`} 
                            className="btn btn-warning"
                        >
                            Évaluer
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RatingBanner;